import { Container } from "@material-ui/core";
import useLanguageStore from "@stores/languageStore";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SEOHead from "../../components/SEOHead";
import SectionHeader from "../../components/SectionHeader";
import { getStoneTypeBySlug } from "../../data/stoneTypesData";

const StoneTypeLandingPage = () => {
	const { stoneSlug } = useParams();
	const { t } = useTranslation();
	const { language } = useLanguageStore();
	const isRtl = language === "he";
	const stoneType = getStoneTypeBySlug(stoneSlug);

	if (!stoneType) {
		return (
			<div
				className={`min-h-[calc(100vh-64px)] py-20 ${isRtl ? "rtl" : "ltr"}`}
			>
				<Container>
					<h1>{t("error.title")}</h1>
					<p>{t("error.message")}</p>
				</Container>
			</div>
		);
	}

	const { meta, h1, content } = stoneType;

	return (
		<div
			className={`min-h-[calc(100vh-64px)] py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
				isRtl ? "rtl" : "ltr"
			}`}
		>
			<SEOHead title={meta.title[language]} description={meta.description[language]} />
			<Container maxWidth="lg" className="px-4 sm:px-8">
				<SectionHeader title={h1[language]} className="mb-12" titleWeight="800" component="h1" />

				<div
					className={`leading-relaxed text-base mb-8 ${isRtl ? "text-right" : "text-left"}`}
				>
					<p>{content.intro[language]}</p>
				</div>

				<h2
					className={`text-2xl font-bold mb-6 ${isRtl ? "text-right" : "text-left"}`}
				>
					{t("stoneTypes.advantages")}
				</h2>

				<ul className={`space-y-4 mb-8 ${isRtl ? "text-right" : "text-left"}`}>
					{content.advantages.map((advantage, index) => (
						<li key={index} className="flex items-start">
							<span className={`font-bold mr-2 ${isRtl ? "ml-2 mr-0" : ""}`}>
								•
							</span>
							<span>
								<strong>{advantage.title[language]}: </strong>
								{advantage.description[language]}
							</span>
						</li>
					))}
				</ul>

				<h2
					className={`text-2xl font-bold mb-6 ${isRtl ? "text-right" : "text-left"}`}
				>
					{t("stoneTypes.suitability")}
				</h2>
				<div
					className={`leading-relaxed text-base mb-8 ${isRtl ? "text-right" : "text-left"}`}
				>
					<p>{content.suitability[language]}</p>
				</div>
			</Container>
		</div>
	);
};

export default StoneTypeLandingPage;

